import { Grid, Alert, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import AddNewComponentModal from './AddNewComponentModal';
import LoadComponentTable from './LoadComponentTable';
import ComponentLoadHistory from '../details/loading/ComponentLoadHistory';

LoadComponent.propTypes = {
  componentsList: PropTypes.object,
  setComponentsList: PropTypes.func,
  systemType: PropTypes.string,
  selectedSnapshot: PropTypes.object
};

export default function LoadComponent({
  componentsList,
  setComponentsList,
  systemType,
  selectedSnapshot
}) {
  return (
    <Grid data-testid="load-component" container mb={2}>
      <Grid item xs={12}>
        <AddNewComponentModal
          componentsList={componentsList}
          setComponentsList={setComponentsList}
          systemType={systemType}
        />
        <Typography variant="subtitle1" color="gray" sx={{ paddingLeft: 1, marginTop: 2 }}>
          Components
        </Typography>
        <LoadComponentTable componentsList={componentsList} setComponentsList={setComponentsList} />
        <Alert severity="info">
          The vrack must have the kit configuration that allows the specified components.
        </Alert>
        {selectedSnapshot && (
          <ComponentLoadHistory
            rackDetails={selectedSnapshot.rack_details}
            title="Components from Snapshot"
          />
        )}
      </Grid>
    </Grid>
  );
}
